// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Nexa-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Nexa-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cormorant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cormorant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Cormorant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Cormorant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Cormorant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Bruney.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/GeneralSans-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/GeneralSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: "Bruney";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-style: normal;
  font-weight: 700;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

body {
  font-family: GeneralSans, sans-serif;
}

.projects__maintitle {
  font-size: 1.3rem;
  padding-top: 4rem;
  text-align: center;
  padding-bottom: 1rem;
}
@media (min-width: 768px) {
  .projects__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 0.7rem;
    padding-bottom: 2rem;
  }
}
@media (min-width: 768px) {
  .projects__parent {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 2rem;
  }
}
.projects__niagaraone--title, .projects__ancasterone--title, .projects__oakvillebath--title, .projects__burligntonone--title, .projects__mississaugastore--title, .projects__miltoneone--title, .projects__burligntontwo--title, .projects__colborneone--title, .projects__mississaugatwo--title, .projects__torontoshelbysone--title, .projects__oakvilletwo--title, .projects__torontoshelbystwo--title {
  font-size: 1rem;
  text-align: center;
  padding-top: 0.7rem;
  padding-bottom: 2rem;
}
.projects__niagaraone--image, .projects__ancasterone--image, .projects__oakvillebath--image, .projects__burligntonone--image, .projects__mississaugastore--image, .projects__miltoneone--image, .projects__burligntontwo--image, .projects__colborneone--image, .projects__mississaugatwo--image, .projects__torontoshelbysone--image, .projects__oakvilletwo--image, .projects__torontoshelbystwo--image {
  display: block;
  width: 60vw;
  aspect-ratio: 16/9;
  margin: auto;
  border-radius: 4px;
  transition: transform 1s ease, box-shadow 0.3s ease;
}
@media (min-width: 768px) {
  .projects__niagaraone--image, .projects__ancasterone--image, .projects__oakvillebath--image, .projects__burligntonone--image, .projects__mississaugastore--image, .projects__miltoneone--image, .projects__burligntontwo--image, .projects__colborneone--image, .projects__mississaugatwo--image, .projects__torontoshelbysone--image, .projects__oakvilletwo--image, .projects__torontoshelbystwo--image {
    width: 30vw;
  }
}
.projects__niagaraone--image:hover, .projects__ancasterone--image:hover, .projects__oakvillebath--image:hover, .projects__burligntonone--image:hover, .projects__mississaugastore--image:hover, .projects__miltoneone--image:hover, .projects__burligntontwo--image:hover, .projects__colborneone--image:hover, .projects__mississaugatwo--image:hover, .projects__torontoshelbysone--image:hover, .projects__oakvilletwo--image:hover, .projects__torontoshelbystwo--image:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/styles/partials/_typography.scss","webpack://./src/pages/OurProjectsPage/OurProjects.scss","webpack://./src/styles/partials/_global.scss","webpack://./src/styles/partials/_mixins.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ACzEA;;;EAGI,sBAAA;EACA,SAAA;AD2EJ;;ACzEA;EACI,oCAAA;AD4EJ;;AAjFI;EACI,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAoFR;AE3FI;EFSA;IAEQ,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,mBAAA;IACA,oBAAA;EAoFV;AACF;AErGI;EFmBA;IAEQ,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,SAAA;EAoFV;AACF;AA/EQ;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAiFZ;AA/EQ;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;AAiFZ;AE3HI;EFoCI;IAQQ,WAAA;EAmFd;AACF;AAlFY;EACI,sBAAA;EACA,yCAAA;AAoFhB","sourcesContent":["@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Bold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Light.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Regular.ttf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Medium.ttf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-SemiBold.ttf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Bold.ttf);\n    font-style: normal;\n    font-weight: 700;\n}\n@font-face{\n    font-family: \"Bruney\";\n    src: url(../../assets/fonts/Bruney.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Extralight.otf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Regular.otf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Semibold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Bold.otf);\n    font-style: normal;\n    font-weight: 700;\n}\n","@use \"../../styles/partials/variables\" as *;\n@use \"../../styles/partials/typography\" as *;\n@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/_global\" as *;\n\n.projects{\n    &__maintitle{\n        font-size: 1.3rem;\n        padding-top: 4rem;\n        text-align: center;\n        padding-bottom: 1rem;\n    }\n    &__wrapper{\n        @include tablet-and-desktop{\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            text-align: center;\n            padding-top: 0.7rem;\n            padding-bottom: 2rem;\n        }\n    }\n    &__parent{\n        @include tablet-and-desktop{\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n            gap: 2rem;\n        }\n    }\n    &__niagaraone, &__ancasterone, &__oakvillebath, &__burligntonone, &__mississaugastore, &__miltoneone, &__burligntontwo, &__colborneone, &__mississaugatwo, &__torontoshelbysone, &__oakvilletwo, &__torontoshelbystwo{\n        // overflow: hidden;\n\n        &--title{\n            font-size: 1rem;\n            text-align: center;\n            padding-top: 0.7rem;\n            padding-bottom: 2rem;\n        }\n        &--image{\n            display: block;\n            width: 60vw;\n            aspect-ratio: 16/9;\n            margin: auto;\n            border-radius: 4px;\n            transition: transform 1s ease, box-shadow 0.3s ease;;\n            @include tablet-and-desktop{\n                width: 30vw;\n            }\n            &:hover{\n                transform: scale(1.05);\n                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);\n            }\n        }\n    }\n\n}","@use \"./variables\" as *;\n@use \"./typography\" as *;\n@use \"./mixins\" as *;\n\n*,\n*::before,\n*::after{\n    box-sizing: border-box;\n    margin: 0;\n}\nbody{\n    font-family: GeneralSans, sans-serif;\n}\n","@use \"./variables\" as *;\n\n@mixin tablet-and-desktop {\n    @media (min-width: $tablet-breakpoint) {\n        @content;\n    }\n}\n@mixin desktop {\n    @media (min-width: $desktop-breakpoint) {\n        @content;\n    }\n}\n\n@mixin big-mobile-screen {\n    @media (min-width: 450px) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
